<template>
  <section class="school-new-support">
    <div class="school-new-support__title">
      <h2>социализация и&nbsp;поддержка</h2>
      <p>
        родители и&nbsp;дети не&nbsp;останутся в&nbsp;вакууме, мы создаем комфортную среду для
        обучения и развития вашего ребенка: социальная активность, мероприятия
        и&nbsp;постоянная поддержка&nbsp;— <span>мы&nbsp;всегда&nbsp;рядом!</span>
      </p>
    </div>

    <div class="school-new-support__items">
      <!--<div class="school-new-support__block school-new-support__block-1">-->
      <!--  <h6 class="school-new-support__block_title">-->
      <!--    онлайн мероприятия-->
      <!--  </h6>-->
      <!--  <p class="school-new-support__block_text">-->
      <!--    проводим онлайн-форумы с&nbsp;участием представителей бизнеса, организуем открытые-->
      <!--    уроки, дистанционные экскурсии и&nbsp;лекции для&nbsp;учеников-->
      <!--  </p>-->
      <!--</div>-->

      <div class="school-new-support__block school-new-support__block-1">
        <h6>вручение аттестатов на&nbsp;выпускном 2024</h6>
        <video
          src="/v2/school-new/quality/video.mp4"
          autoplay
          :muted="videoMuted"
          playsinline
          preload="none"
          loop
        />
        <button
          class="m-btn video__mute"
          @click="videoMuted = !videoMuted"
        >
          <img :src="`/v2/main/goal/${videoMuted ? 'mute' : 'no-mute' }.svg`" alt="mute">
        </button>
      </div>

      <div class="school-new-support__block school-new-support__block-2">
        <h6 class="school-new-support__block_title">
          поддержка родителей
        </h6>
        <p class="school-new-support__block_text">
          регулярно информируем родителей о&nbsp;достижениях их&nbsp;детей.
          Будьте в&nbsp;курсе прогресса ребенка
        </p>
      </div>

      <div class="school-new-support__block school-new-support__block-3">
        <h6 class="school-new-support__block_title">
          комьюнити для&nbsp;родителей и&nbsp;учеников
        </h6>
        <p class="school-new-support__block_text">
          место для&nbsp;общения, обмена опытом и&nbsp;поддержки 24/7
        </p>

        <div class="school-new-support__block_soc">
          <a
            href="https://t.me/synergyschool"
            target="_blank"
          >
            <img
              src="/v2/school-new/support/telegram.svg"
              alt="telegram"
            >
          </a>
          <a
            href="https://vk.com/synergyonlineschool"
            target="_blank"
          >
            <img
              src="/v2/school-new/support/vk.svg"
              alt="vk"
            >
          </a>
        </div>
      </div>

      <div class="school-new-support__block school-new-support__block-4">
        <h6 class="school-new-support__block_title">
          вне учебы — еще интереснее!
        </h6>
        <p class="school-new-support__block_text">
          <span>онлайн:</span> форумы с&nbsp;предпринимателями, открытые лекции,
          виртуальные экскурсии и&nbsp;мастер-классы от&nbsp;профессионалов
          <br>
          <br>
          <span>офлайн:</span> прогулки в&nbsp;парках, походы в&nbsp;музеи и&nbsp;зоопарки,
          творческие встречи и&nbsp;яркий выпускной с&nbsp;одноклассниками
        </p>
      </div>
    </div>

    <div
      v-if="onlineSchoolOtherPage"
      class="other-school-support__banner"
    >
      <h3><span>чек-лист</span> по&nbsp;переходу на&nbsp;семейное образование</h3>

      <button
        class="m-btn"
        @click="openModal(MODAL_TYPES.checkList)"
      >
        скачать чек-лист
      </button>
    </div>

    <div
      v-else
      class="school-new-support__banner"
    >
      <h3>чек-лист по&nbsp;переходу в&nbsp;онлайн‑школу</h3>

      <p>
        смотрите видео с&nbsp;директором онлайн‑школы «Синергия» о&nbsp;плюсах
        и&nbsp;минусах семейной и&nbsp;заочной формы обучения
      </p>

      <button
        class="m-btn school-new-support__banner_play"
        @click="openVideoModal('/v2/school/edu-forms/Онлайн школа 29 05.mp4')"
      >
        <span>смотреть видео</span>
        <img
          src="/v2/school-new/support/play.svg"
          alt="play"
        >
      </button>

      <button
        class="m-btn school-new-support__banner_btn"
        @click="openModal(MODAL_TYPES.checkList)"
      >
        скачать чек-лист
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../common/AppHeader/data';

export default {
  name: 'SchoolNewSupport',
  data: () => ({
    videoMuted: true,
    MODAL_TYPES,
  }),
  computed: {
    onlineSchoolOtherPage() {
      return [
        'online-school-zaochnoe-obuchenie',
        'online-school-attestacii-i-prikreplenie',
        'online-school-vechernee-obuchenie',
        'online-school-semeinoe-obuchenie',
        'online-school-semeinoe-obuchenie-ceny',
      ].includes(this.$route.name);
    },
  },
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
    ...mapActions('modals', {
      openVideoModal: 'openVideo',
    }),
  },
};
</script>

<style scoped lang="scss">

.school-new-support {
  .school-new-support__title {
    display: flex;
    gap: 1.25rem;
    margin-bottom: 2.5rem;

    @include media-down($size-mobile) {
      flex-direction: column;
      gap: 0.8rem;
    }

    h2 {
      width: calc(var(--scale) * 910);
      flex-shrink: 0;

      font-weight: 500;
      font-size: calc(var(--scale) * 86);
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 364);
        font-size: calc(var(--scale) * 40);
      }

      @include media-down($size-mobile) {
        width: calc(var(--scale) * 334);
      }
    }

    p {
      padding-top: calc(var(--scale) * 20);
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        padding-top: calc(var(--scale) * 8);
        font-size: 1.8rem;
        letter-spacing: -0.02em;
      }

      @include media-down($size-mobile) {
        padding-top: 0;
        width: calc(var(--scale) * 334);
      }

      span {
        color: #FF5319;
      }
    }
  }

  .school-new-support__items {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 1.25rem / 2));
    gap: 1.25rem;

    @include media-down($size-tablet) {
      grid-template-columns: repeat(2, calc(50% - 0.4rem));
      grid-template-rows: calc(var(--scale) * 512) calc(var(--scale) * 512);
      gap: 0.8rem;
    }

    @include media-down($size-mobile) {
      grid-template-columns: 100%;
      grid-template-rows: repeat(4, 51.2rem);
    }
  }

  .school-new-support__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2.5rem;
    position: relative;
    background-color: #FFFFFF;
    background-repeat: no-repeat;
    border-radius: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.6rem 1.4rem 1.6rem 1.6rem;
    }

    &_title {
      margin-bottom: 0.75rem;
      max-width: calc(var(--scale) * 560);

      font-style: normal;
      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: 0.8rem;
        font-size: 4rem;
        letter-spacing: -0.04em;
      }
    }

    &_text {
      max-width: calc(var(--scale) * 560);

      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
        line-height: 110%;
      }
    }

    &_soc {
      display: flex;
      gap: calc(var(--scale) * 8);

      img {
        width: calc(var(--scale) * 72);

        @include media-down($size-tablet) {
          width: calc(var(--scale) * 56);
        }
      }
    }

    &-1 {
      //background-image: url("/v2/school-new/support/1.svg");
      //background-position: bottom calc(var(--scale) * 40) right;
      //background-size: calc(100% - var(--scale) * 40) auto;
      //
      //@include media-down($size-tablet) {
      //  background-image: url("/v2/school-new/support/1-tablet.svg");
      //  background-position: bottom calc(var(--scale) * 20) right;
      //  background-size: calc(100% - var(--scale) * 20) auto;
      //}

      padding: 0;
      overflow: hidden;

      h6 {
        position: absolute;
        top: calc(var(--scale) * 32);
        left: calc(var(--scale) * 40);
        width: calc(var(--scale) * 735);

        font-weight: 500;
        font-size: calc(var(--scale) * 64);
        line-height: 95%;
        letter-spacing: -0.02em;
        color: #FFFFFF;
        text-align: left;

        @include media-down($size-tablet) {
          border-radius: calc(var(--scale) * 24);
          top: calc(var(--scale) * 16);
          left: calc(var(--scale) * 16);
          transform: none;
          width: calc(100% - var(--scale) * 32);
          font-size: calc(var(--scale) * 40);
          line-height: 110%;
          letter-spacing: -0.04em;
          text-align: left;
        }
      }

      button {
        position: absolute;
        top: calc(var(--scale) * 50);
        right: calc(var(--scale) * 40);
        width: calc(var(--scale) * 32);
        aspect-ratio: 1/1;

        @include media-down($size-tablet) {
          width: calc(var(--scale) * 24);
          top: calc(var(--scale) * 28);
          right: calc(var(--scale) * 27);
        }

        img {
          width: 100%;
        }
      }

      video {
        line-height: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &-2 {
      background-image: url("/v2/school-new/support/2.webp");
      background-position: bottom;
      background-size: 100% auto;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/support/2-tablet.webp");
      }
    }

    &-3 {
      background-image: url("/v2/school-new/support/3.webp");
      background-position: bottom right;
      background-size: auto 100%;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/support/3-tablet.webp");
        background-size: 100% auto;
      }

      .school-new-support__block_title {
        max-width: calc(var(--scale) * 405);
      }

      .school-new-support__block_text {
        margin-bottom: auto;
        max-width: calc(var(--scale) * 435);
      }
    }

    &-4 {
      margin-top: calc(-1 * var(--scale) * 227);

      background-image: url("/v2/school-new/support/4.webp");
      background-position: bottom calc(-1 * var(--scale) * 110) center;
      background-size: 100% auto;

      @include media-down($size-tablet) {
        margin-top: 0;
        background-image: url("/v2/school-new/support/4-tablet.webp");
        background-position: bottom calc(-1 * var(--scale) * 80) center;
      }

      .school-new-support__block_title,
      .school-new-support__block_text {
        max-width: calc(var(--scale) * 715);

        span {
          color: #FF5319;
        }
      }
    }

    &-2,
    &-3 {
      height: calc(var(--scale) * 493);

      @include media-down($size-tablet) {
        height: 100%;
      }
    }

    &-1,
    &-4 {
      height: calc(var(--scale) * 720);

      @include media-down($size-tablet) {
        height: 100%;
      }
    }
  }

  &__banner {
    margin-top: calc(var(--scale) * 20);
    position: relative;
    padding: calc(var(--scale) * 16) calc(var(--scale) * 40);

    background-image: url("/v2/school-new/support/banner.webp");
    background-size: 100% 100%;

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 8);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      background-image: url("/v2/school-new/support/banner-tablet.webp");
    }

    @include media-down($size-mobile) {
      background-size: cover;
      background-image: url("/v2/school-new/support/banner-mob.webp");
    }

    h3 {
      margin-bottom: calc(var(--scale) * 18);
      max-width: calc(var(--scale) * 869);

      font-weight: 500;
      font-size: calc(var(--scale) * 86);
      line-height: 90%;
      letter-spacing: -0.04em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding-left: calc(var(--scale) * 8);
        margin-bottom: calc(var(--scale) * 74);
        max-width: calc(var(--scale) * 334);
        font-size: calc(var(--scale) * 40);
        line-height: 110%;
      }

      @include media-down($size-mobile) {
        margin-bottom: calc(var(--scale) * 16);
      }
    }

    p {
      position: absolute;
      right: calc(var(--scale) * 40);
      top: calc(var(--scale) * 32);
      max-width: calc(var(--scale) * 558);

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      text-align: right;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        display: none;
      }
    }

    .school-new-support__banner_play {
      position: absolute;
      right: calc(var(--scale) * 40);
      bottom: calc(var(--scale) * 40);
      display: flex;
      align-items: center;
      gap: calc(var(--scale) * 16);

      @include media-down($size-tablet) {
        top: calc(var(--scale) * 20);
        bottom: auto;
        right: calc(var(--scale) * 16);
        gap: calc(var(--scale) * 8);
      }

      @include media-down($size-mobile) {
        position: static;
        margin-bottom: calc(var(--scale) * 224);
        padding-left: calc(var(--scale) * 8);
        flex-direction: row-reverse;
      }

      &:hover span {
        text-decoration: none;
      }

      span {
        font-weight: 400;
        font-size: calc(var(--scale) * 20);
        line-height: 130%;
        text-decoration-line: underline;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 16);
          letter-spacing: -0.02em;
        }
      }

      img {
        width: calc(var(--scale) * 50);

        @include media-down($size-tablet) {
          width: calc(var(--scale) * 32);
        }
      }
    }

    .school-new-support__banner_btn {
      padding: calc(var(--scale) * 44) calc(var(--scale) * 56);
      background-color: #5237E6;
      box-shadow:
        calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
      border-radius: calc(var(--scale) * 40);

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 30) calc(var(--scale) * 56);
        border-radius: calc(var(--scale) * 24);
        font-size: calc(var(--scale) * 18);
        letter-spacing: -0.02em;
      }

      @include media-down($size-mobile) {
        width: 100%;
      }
    }
  }
}

.other-school-support__banner {
  height: calc(var(--scale) * 350);
  margin-top: calc(var(--scale) * 20);
  padding: calc(var(--scale) * 24) calc(var(--scale) * 40) calc(var(--scale) * 40);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-image: url("/v2/school-new/other-pages/support/banner.webp");
  background-size: cover;
  border-radius: calc(var(--scale) * 60);

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 140);
    margin-top: calc(var(--scale) * 8);
    padding: calc(var(--scale) * 9) calc(var(--scale) * 16) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 24);
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 366);
    padding: calc(var(--scale) * 12) calc(var(--scale) * 16) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/school-new/other-pages/support/banner-mob.webp");
  }

  h3 {
    max-width: calc(var(--scale) * 1207);

    font-weight: 500;
    font-size: calc(var(--scale) * 80);
    line-height: 90%;
    letter-spacing: -0.04em;
    color: #4F0338;

    span {
      color: #D524A9;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 450);
      font-size: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 36);
    }
  }

  .m-btn {
    margin-top: auto;
    padding: calc(var(--scale) * 34) calc(var(--scale) * 56);
    background-color: #76195A;
    border-radius: calc(var(--scale) * 24);

    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 14) calc(var(--scale) * 22);
      border-radius: calc(var(--scale) * 16);
      font-size: calc(var(--scale) * 18);
      letter-spacing: -0.02em;
    }
  }
}

</style>
